import {call, put, select} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {setNotificationError} from '@pluto/notification';
import {getTargetAgeOptions} from '@pluto/rest';
import {setTargetAgeOptionsAction} from '../TargetAgeAction';
import {selectTargetAge} from '../TargetAgeSelector';
import {TargetAgeCountryItem} from '../../TargetAgeTypes';

export interface TargetAgeWorkerPayload {
    countryCode: string;
}

export const getIsCountryInStore = (data: TargetAgeCountryItem[], countryCode: string) => {
    return Boolean(data.find((item) => item.countryCode === countryCode));
}

export function* fetchTargetAgeWorker({payload}: Action<TargetAgeWorkerPayload>) {
    try {
        const {countryCode} = payload;
        const {targetAgeData} = yield select(selectTargetAge);
        const isCountryInStore = getIsCountryInStore(targetAgeData, countryCode);

        if (!isCountryInStore) {
            const targetAge = yield call(getTargetAgeOptions, countryCode);

            yield put(setTargetAgeOptionsAction(targetAge));
        }
    } catch(error) {
        yield put(setNotificationError(error.message));
    }
}
